// Flip to false to fall back to the plain toast + summary-panel behavior
// (no stage-by-stage popup) for SentinelOne vulnerability remediation.
// Patchifi software and OS updates report through RemediationJobProvider, which is always on.
export const ENABLE_REMEDIATION_PROGRESS_MODAL = false;

// Controls the "Run Script" / custom script action on patchCenter/Action.
export const ENABLE_PATCH_ACTION_CUSTOM_SCRIPT = false;

// Controls the "Uninstall Software" action on patchCenter/Action, and the
// corresponding "Uninstalled Software" summary card on patchCenter/Preview&Approve.
export const ENABLE_PATCH_ACTION_UNINSTALL_SOFTWARE = false;
